import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Api } from "../../../../helpers/Api";

const Nav2 = ({ user, dispatchUpdate }) => {
    const [clicked, setClicked] = useState(0);

    return <ul>
        <li  
        className={clicked === 0 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to={"/ReportRoleWise"}>
                <img src='../../../../images/dashboard.png' alt="Icon" />
                <span>Reports</span>
            </Link>
        </li>
    </ul>
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchUpdate: (user) => dispatch({ type: 'UPDATE_USER', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Nav2)
